import { Component, h } from "preact";
import EventController from "../../../shared/controller/event-controller";
import Uploader from "../../uploader";
import {
  IDictionary,
  ILabelOptionValue,
  IOption,
  IReactConfiguration,
} from "../../../typings";
import OutputController from "../../../shared/controller/output-controller";
import TemplateController from "../../../shared/controller/template-controller";
import LabelSvgSprite from "../../label-uploader/label-svg-sprite";

export default class LabelColorPickerComponent extends Component<
  ILabelColorProps,
  ILabelColorState
> {
  private timeout: number;
  private panelElement: HTMLElement;
  constructor(props: ILabelColorProps) {
    super(props);

    this.search = this.search.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  componentDidMount(): void {
    this.loadEventListeners();
  }

  loadEventListeners(): void {
    setTimeout(
      () =>
        document.body.addEventListener("click", (event: MouseEvent) => {
          if (this.panelElement.contains(event.target as Node)) {
            return;
          }

          //this.props.closePanel();
        }),
      1,
    );
  }

  search(event: Event): void {
    const value: string = (event.target as any).value;

    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }

    this.timeout = window.setTimeout(() => {
      this.setState({
        searchQuery: value,
      });
    }, 100);
  }

  render(): JSX.Element {
    return (
      <dialog
        className="absolute top-0 left-0 right-0 w-full h-full overflow-hidden rounded-xl p-0"
        role="alertdialog"
        open
        ref={(ref: HTMLElement) => {
          if (!ref) {
            return;
          }

          if (ref === this.panelElement) {
            return;
          }

          this.panelElement = ref;
        }}
      >
        <div className="popup__handler">
          <div className="optionTitleWrapper">
            <h3>Edit color</h3>
            <div className="flex space-x-8">
              <button
                className="flex items-center justify-center p-4 md:py-6 lg:px-3 lg:py-2.5 cursor-pointer"
                onClick={() => this.props.closePanel()}
              >
                <LabelSvgSprite
                  viewBox="0 0 32 32"
                  cssClass={"w-6 h-6"}
                  conf={this.props.conf}
                  imageCode="close"
                  alt={"Close"}
                />
              </button>
            </div>
          </div>
          <div className="p-6 lg:p-8 pt-0 lg:pt-0">
            <div className="input__box">
              <input
                className="w-full"
                type="text"
                placeholder={this.props.option.meta.fields.searchPlaceholder}
                value={this.state.searchQuery}
                onInput={this.search}
              />
            </div>
          </div>
          <div className="bg-gray-lighter p-6 lg:p-8 max-h-48 lg:max-h-80 overflow-y-scroll scrollbar hide-scrollbar-mobile lg:pr-6">
            <div>
              {Object.keys(this.props.colorHashTable)
                .filter((index: string) => {
                  if (this.props.exclude.indexOf(index) !== -1) {
                    return false;
                  }

                  return (
                    !this.state.searchQuery ||
                    index.indexOf(this.state.searchQuery.toLowerCase()) !== -1
                  );
                })
                .map((index: string) => {
                  const value: ILabelOptionValue =
                    this.props.colorHashTable[index];
                  return (
                    <div
                      className="grid items-center justify-center grid-cols-12 py-2 cursor-pointer"
                      key={value.value}
                      onClick={() => this.props.setColor(value.value)}
                    >
                      <div className="flex items-center col-span-6 sm:col-span-4 space-x-2">
                        <div
                          className="w-8 h-8 border border-solid rounded-full border-gray "
                          style={
                            "background-color: " +
                            value.attributes.hex.value +
                            ";"
                          }
                        />
                        <span>{value.meta.name}</span>
                      </div>
                      <div className="col-span-4 sm:col-span-3">
                        <div>{value.attributes.pantone.value}</div>
                      </div>
                      <div className="col-span-3 hidden sm:block">
                        <div>{value.attributes.hex.value}</div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </dialog>
    );
  }

  private closePanel(): void {
    this.setState({ searchQuery: "" });
    this.props.closePanel();
  }
}

interface ILabelColorProps {
  main: Uploader;
  conf: IReactConfiguration;
  option: IOption;
  colors: ILabelOptionValue[];
  exclude: string[];

  eventController: EventController;
  outputController: OutputController;
  templateController: TemplateController;

  color: ILabelOptionValue;
  colorHashTable: IDictionary<ILabelOptionValue>;
  setColor: (value: string) => void;
  closePanel: () => void;
}

interface ILabelColorState {
  colors: ILabelOptionValue[];
  editColor?: ILabelOptionValue;
  searchQuery?: string;
}
